function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { MARKS, INLINES, BLOCKS } from '@contentful/rich-text-types';
import { Highlight, themes } from 'prism-react-renderer';
import styled from 'styled-components';
import { media } from '../../../breakpoints.js';
import { ANALYTICS_KEY } from '../../../constants.js';
import '../../Div/index.js';
import { BlockEmbeddedEntry } from '../components/BlockEmbeddedEntry.js';
import { InlineHyperLink } from '../components/InlineHyperLink.js';
import { ListItem } from '../components/ListItem.js';
import { Paragraph } from '../components/Paragraph.js';
import { composeRichTextComponents } from './composeRichTextComponents.js';
import { jsx } from 'react/jsx-runtime';
import { Div } from '../../Div/Div.js';
const getLinesToHighlight = ({
  props
}) => {
  if (!props.children) {
    return '';
  }
  return props.children;
};
const articleRichTextOptionsConfig = {
  customRenderMarks: {
    [MARKS.CODE]: function Code(text) {
      const textToRender = typeof text === 'string' ? text : getLinesToHighlight(text);
      return /*#__PURE__*/jsx(Highlight, {
        theme: themes.github,
        code: textToRender,
        language: "tsx",
        children: ({
          tokens,
          getLineProps,
          getTokenProps
        }) => /*#__PURE__*/jsx(Div, {
          as: "pre",
          flexDirection: "column",
          overflowX: "scroll",
          css: {
            /* Chrome */
            '::-webkit-scrollbar': {
              display: 'none'
            },
            /* Firefox */
            'scrollbar-width': 'none'
          },
          children: tokens.map((line, i) => /*#__PURE__*/jsx(Div, _objectSpread(_objectSpread({}, getLineProps({
            line
          })), {}, {
            as: "div",
            children: line.map((token, key) => /*#__PURE__*/jsx("span", _objectSpread({}, getTokenProps({
              token
            })), key))
          }), i))
        })
      });
    }
  },
  customRenderOptions: {
    [INLINES.HYPERLINK]: props => InlineHyperLink(_objectSpread(_objectSpread({}, props), {}, {
      dataQa: ANALYTICS_KEY.ArticleRichText,
      foregroundInlineLink: props?.foregroundInlineLink
    })),
    [BLOCKS.LIST_ITEM]: props => ListItem(_objectSpread(_objectSpread({}, props), {}, {
      listWrapper: StyledLi,
      color: props?.secondaryColor
    })),
    [BLOCKS.PARAGRAPH]: props => Paragraph(_objectSpread(_objectSpread({}, props), {}, {
      color: props?.secondaryColor
    })),
    [BLOCKS.EMBEDDED_ENTRY]: props => BlockEmbeddedEntry(_objectSpread(_objectSpread({}, props), {}, {
      additionalProps: _objectSpread(_objectSpread({}, props), {}, {
        isFullWidth: false,
        hasSpacingHorizontal: false
      })
    }))
  }
};
const articleRichTextOptions = composeRichTextComponents(articleRichTextOptionsConfig);
const StyledLi = styled.span`
  p {
    padding-top: 12px;
    ${media.md} {
      padding-top: 16px;
    }
  }
  overflow: hidden;
  word-break: break-all;
`;
export { articleRichTextOptions, articleRichTextOptionsConfig };
//# sourceMappingURL=articleRichTextOptions.js.map
